module.exports = __webpack_public_path__ + "img/logo.bak.82bd500a.png";